module.exports = __webpack_public_path__ + "img/竖着的板.f3cfe68d.png";